import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function OverlayComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function OverlayComponent_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1._onClose()); });
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("transparent", ctx_r0.isTransparent);
} }
const _c0 = ["*"];
const KEYCODES = {
    ESC_KEY: 27,
    TAB_KEY: 9,
};
export class OverlayComponent {
    constructor() {
        this.isTransparent = false;
        this.isFocusTrapped = false;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
    }
    _onClose() {
        this.close.emit();
    }
}
OverlayComponent.ɵfac = function OverlayComponent_Factory(t) { return new (t || OverlayComponent)(); };
OverlayComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OverlayComponent, selectors: [["mhe-overlay"]], inputs: { isOpen: "isOpen", isTransparent: "isTransparent", isFocusTrapped: "isFocusTrapped" }, outputs: { close: "close" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [["class", "modal-overlay", 3, "transparent", "click", 4, "ngIf"], [1, "modal-overlay", 3, "click"]], template: function OverlayComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, OverlayComponent_div_0_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, dependencies: [i1.NgIf], styles: [".modal-overlay[_ngcontent-%COMP%] {\n        background-color: rgba(0, 0, 0, 0.4);\n        bottom: 0;\n        left: 0;\n        position: fixed;\n        right: 0;\n        top: 0;\n        z-index: 1;\n      }\n\n      .modal-overlay.transparent[_ngcontent-%COMP%] {\n        background-color: rgba(0, 0, 0, 0);\n      }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverlayComponent, [{
        type: Component,
        args: [{ selector: 'mhe-overlay', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"isOpen\" class=\"modal-overlay\" [class.transparent]=\"isTransparent\" (click)=\"_onClose()\">\n  <ng-content></ng-content>\n</div>\n", styles: ["\n      .modal-overlay {\n        background-color: rgba(0, 0, 0, 0.4);\n        bottom: 0;\n        left: 0;\n        position: fixed;\n        right: 0;\n        top: 0;\n        z-index: 1;\n      }\n\n      .modal-overlay.transparent {\n        background-color: rgba(0, 0, 0, 0);\n      }\n    "] }]
    }], null, { isOpen: [{
            type: Input
        }], isTransparent: [{
            type: Input
        }], isFocusTrapped: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();
